module.exports = __webpack_public_path__ + "media/3_20.d6ff9bbc.wav";